"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var RankedListSearch = /*#__PURE__*/function () {
  function RankedListSearch() {
    var matchFunction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    (0, _classCallCheck2["default"])(this, RankedListSearch);
    this.compare = matchFunction || this.defaultMatcher;
    this.match = 0;
    this.less = -1;
    this.greater = 1;
  }

  (0, _createClass2["default"])(RankedListSearch, [{
    key: "isEqual",
    value: function isEqual(testValue, iterationValue) {
      return this.compare(testValue, iterationValue) === this.match;
    }
  }, {
    key: "defaultMatcher",
    value: function defaultMatcher(testValue, iterationValue) {
      if (testValue === iterationValue) {
        return this.match;
      }

      if (testValue < iterationValue) {
        return this.less;
      }

      return this.greater;
    }
  }]);
  return RankedListSearch;
}();

var _default = RankedListSearch;
exports["default"] = _default;